// export function CycleDialog({
//     open,
//     onClose,
//     titles,
//     ids,
//     currentTitle,
//   }: {
//     open: boolean;
//     onClose: () => void;
//     titles: string[];
//     ids?: string[] | null;
//     currentTitle?: string;
//   }) {
//     if (!open) return null;
  
//     // --- layout
//     const WIDTH = 720;
//     const HEIGHT = 440;
//     const CX = WIDTH / 2;
//     const CY = HEIGHT / 2;
//     const R = Math.min(WIDTH, HEIGHT) / 2 - 86; // node ring radius
//     const NODE_R = 14;
//     const PAD = 18; // trim paths at nodes
  
//     // --- visuals
//     const EDGE_EXISTING = "#94a3b8"; // slate-400
//     const EDGE_NEW = "#2563eb";      // indigo-600
//     const NODE_RING = "#0ea5e9";     // first node
//     const NODE_LAST = "#22c55e";     // last node
//     const LABEL_OFFSET = 42;         // label outside distance
//     const BEND_MIN = 70;
//     const BEND_MAX = 220;
//     const BEND_K = 0.6;            // curvature strength
  
//     // labels
//     const labels = [...titles];
//     if (labels.length) labels[0] = currentTitle?.trim() || labels[0] || "(this template)";
//     const N = Math.max(2, labels.length);
  
//     // nodes on a circle
//     const nodes = Array.from({ length: N }).map((_, i) => {
//       const a = (2 * Math.PI * i) / N - Math.PI / 2;
//       return {
//         x: CX + R * Math.cos(a),
//         y: CY + R * Math.sin(a),
//         angle: a,
//         label: labels[i] || `#${i + 1}`,
//       };
//     });
  
//     /**
//      * Stable outward curve between nodes i -> j.
//      * - Computes a stable chord normal using the unordered pair (min,max).
//      * - Chooses the sign so the curve is **outward** (away from center).
//      * - For N===2, you can pass extraSign = -1 to flip (so the two directions split).
//      */
//     const curveOutward = (i: number, j: number, extraSign: 1 | -1 = 1) => {
//       const A = nodes[i], B = nodes[j];
  
//       // chord for trimming (direction of THIS arrow)
//       let vx = B.x - A.x, vy = B.y - A.y;
//       const d = Math.hypot(vx, vy) || 1;
//       const ux = vx / d, uy = vy / d;
  
//       // stable chord (unordered) -> left normal
//       const ii = Math.min(i, j), jj = Math.max(i, j);
//       const P = nodes[ii], Q = nodes[jj];
//       let svx = Q.x - P.x, svy = Q.y - P.y;
//       const sn = Math.hypot(svx, svy) || 1;
//       const nx = -(svy / sn), ny = svx / sn; // stable left normal
  
//       // outward vs inward: pick sign by dot with center->midpoint
//       const mx0 = (A.x + B.x) / 2, my0 = (A.y + B.y) / 2;
//       const cxm = mx0 - CX, cym = my0 - CY;
//       const outwardSign: 1 | -1 = (nx * cxm + ny * cym) >= 0 ? 1 : -1;
  
//       const s = (outwardSign * extraSign) as 1 | -1;
  
//       // curvature amount
//       const bend = Math.max(BEND_MIN, Math.min(BEND_MAX, d * BEND_K));
  
//       // trimmed endpoints
//       const p0 = { x: A.x + PAD * ux, y: A.y + PAD * uy };
//       const p3 = { x: B.x - PAD * ux, y: B.y - PAD * uy };
  
//       // offset midpoint outward
//       const mx = mx0 + s * bend * nx;
//       const my = my0 + s * bend * ny;
  
//       // smooth controls aimed at the offset midpoint
//       const t1 = 0.45, t2 = 0.55;
//       const p1 = { x: p0.x + t1 * (mx - p0.x), y: p0.y + t1 * (my - p0.y) };
//       const p2 = { x: p3.x + (1 - t2) * (mx - p3.x), y: p3.y + (1 - t2) * (my - p3.y) };
  
//       return `M ${p0.x} ${p0.y} C ${p1.x} ${p1.y} ${p2.x} ${p2.y} ${p3.x} ${p3.y}`;
//     };
  
//     // EXISTING edges: (i+1) -> (i)
//     // NEW edge: 0 -> (N-1)
//     // For 3+ nodes: make **all** edges outward.
//     // For 2 nodes: split directions so they don't overlap (new uses flipped sign).
//     const existingEdges = Array.from({ length: Math.max(0, N - 1) }).map((_, i) => ({
//       d: curveOutward(i + 1, i, 1),
//     }));
//     const newEdge = {
//       d: N === 2 ? curveOutward(0, N - 1, -1) : curveOutward(0, N - 1, 1),
//     };
  
//     const labelPos = (angle: number) => {
//       const x = CX + (R + LABEL_OFFSET) * Math.cos(angle);
//       const y = CY + (R + LABEL_OFFSET) * Math.sin(angle);
//       const cos = Math.cos(angle);
//       const anchor: "start" | "end" | "middle" = Math.abs(cos) < 0.2 ? "middle" : (cos >= 0 ? "start" : "end");
//       return { x, y, anchor };
//     };
  
//     return (
//       <div className="fixed inset-0 z-50 flex items-center justify-center">
//         <div className="absolute inset-0 bg-black/30" onClick={onClose} />
//         <div className="relative z-10 w-[760px] max-w-[92vw] overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-black/5">
//           <div className="flex items-center justify-between border-b px-4 py-3">
//             <h3 className="text-sm font-semibold text-zinc-800">Dependency loop</h3>
//             <button onClick={onClose} className="rounded p-1 text-zinc-500 hover:bg-zinc-100" aria-label="Close">
//               <svg viewBox="0 0 20 20" className="h-5 w-5"><path d="M6 6l8 8M14 6l-8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
//             </button>
//           </div>
  
//           <div className="p-4">
//             {/* Legend */}
//             <div className="mb-2 flex items-center gap-4 text-xs text-zinc-600">
//               <span className="inline-flex items-center gap-2">
//                 <span className="inline-block h-2 w-4 rounded-sm" style={{ background: EDGE_EXISTING }} />
//                 Existing dependency
//               </span>
//               <span className="inline-flex items-center gap-2">
//                 <span className="inline-block h-2 w-4 rounded-sm" style={{ background: EDGE_NEW }} />
//                 New dependency you’re adding
//               </span>
//             </div>
  
//             <svg width={WIDTH} height={HEIGHT} className="mx-auto block">
//               <defs>
//                 <marker id="arrow-old" markerWidth="12" markerHeight="8" refX="10" refY="4" orient="auto">
//                   <path d="M0,0 L10,4 L0,8 z" fill={EDGE_EXISTING} />
//                 </marker>
//                 <marker id="arrow-new" markerWidth="14" markerHeight="10" refX="12" refY="5" orient="auto">
//                   <path d="M0,0 L12,5 L0,10 z" fill={EDGE_NEW} />
//                 </marker>
//                 <filter id="soft" x="-20%" y="-20%" width="140%" height="140%">
//                   <feDropShadow dx="0" dy="0" stdDeviation="2" floodColor="#00000022" />
//                 </filter>
//               </defs>
  
//               {/* existing edges (all outward for N>=3) */}
//               {existingEdges.map((e, i) => (
//                 <path
//                   key={`old-${i}`}
//                   d={e.d}
//                   fill="none"
//                   stroke={EDGE_EXISTING}
//                   strokeWidth={2}
//                   markerEnd="url(#arrow-old)"
//                 />
//               ))}
  
//               {/* new edge */}
//               <path
//                 d={newEdge.d}
//                 fill="none"
//                 stroke={EDGE_NEW}
//                 strokeWidth={3}
//                 markerEnd="url(#arrow-new)"
//                 filter="url(#soft)"
//               />
  
//               {/* nodes + outside labels */}
//               {nodes.map((n, i) => {
//                 const isFirst = i === 0;
//                 const isLast = i === N - 1;
//                 const lp = labelPos(n.angle);
//                 return (
//                   <g key={`n-${i}`}>
//                     {isFirst && <circle cx={n.x} cy={n.y} r={NODE_R + 8} fill="none" stroke={NODE_RING} strokeWidth={2} />}
//                     {isLast && <circle cx={n.x} cy={n.y} r={NODE_R + 6} fill="none" stroke={NODE_LAST} strokeDasharray="4 2" />}
//                     <circle cx={n.x} cy={n.y} r={NODE_R} fill="#fff" stroke="#cbd5e1" />
//                     <text
//                       x={lp.x}
//                       y={lp.y}
//                       textAnchor={lp.anchor}
//                       dominantBaseline="middle"
//                       className="fill-zinc-700 text-[12px]"
//                     >
//                       {n.label}
//                     </text>
//                   </g>
//                 );
//               })}
//             </svg>
  
//             {/* textual path */}
//             <div className="mt-3 rounded-md bg-zinc-50 p-2 text-center text-xs text-zinc-600">
//               {labels.join(" → ")} <span className="text-zinc-400">→</span>{" "}
//               <span style={{ color: EDGE_NEW, fontWeight: 600 }}>{labels[0]}</span>
//             </div>
//           </div>
  
//           <div className="flex justify-end gap-2 border-t px-4 py-3">
//             <button onClick={onClose} className="rounded-md border border-zinc-300 px-3 py-1.5 text-sm text-zinc-700 hover:bg-zinc-50">
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }
import React from "react";

/**
 * CycleDialog
 *
 * Props:
 * - open: boolean
 * - onClose: () => void
 * - titles: string[]           // friendly labels (fallback)
 * - ids?: string[] | null      // cycle path as ids (optional)
 * - currentTitle?: string      // the title of the template being edited (optional)
 * - graph?: { nodes: {id:string; title?:string; [k:string]:any }[]; edges: {from:string; to:string}[] }  // optional published graph
 *
 * Behavior:
 * - If `ids` + `graph` are present: renders the nodes in the `ids` order (labels come from graph nodes.title or titles fallback).
 * - If only `ids` present: renders nodes in that order and draws the "new edge" (0 -> last) + existing ring edges.
 * - If only `graph` present: renders the first N nodes from graph.nodes and draws edges among them (useful to inspect overall graph).
 * - Always renders a textual nodes/edges panel below the SVG so you can inspect exact ids.
 */
export function CycleDialog({
  open,
  onClose,
  titles,
  ids,
  currentTitle,
  graph,
}: {
  open: boolean;
  onClose: () => void;
  titles: string[];
  ids?: string[] | null;
  currentTitle?: string;
  graph?: { nodes: { id: string; title?: string; [k: string]: any }[]; edges: { from: string; to: string }[] } | null;
}) {
  if (!open) return null;

  // ---- layout constants ----
  const WIDTH = 720;
  const HEIGHT = 440;
  const CX = WIDTH / 2;
  const CY = HEIGHT / 2;
  const R = Math.min(WIDTH, HEIGHT) / 2 - 86; // node ring radius
  const NODE_R = 14;
  const PAD = 18; // trim paths at nodes

  // ---- visuals ----
  const EDGE_EXISTING = "#94a3b8"; // slate-400
  const EDGE_NEW = "#2563eb"; // indigo-600
  const NODE_RING = "#0ea5e9"; // first node highlight
  const NODE_LAST = "#22c55e"; // last node highlight
  const LABEL_OFFSET = 42; // label outside distance
  const BEND_MIN = 70;
  const BEND_MAX = 220;
  const BEND_K = 0.6; // curvature strength

  // ---- Determine node list to render and labels ----
  // priority:
  // 1) ids + graph => use graph nodes ordered by ids
  // 2) ids only => use ids with titles fallback
  // 3) graph only => use graph.nodes (take up to M)
  // 4) titles fallback

  // helper: map graph nodes by id
  const graphMap = new Map<string, { id: string; title?: string }>();
  if (graph?.nodes) {
    for (const n of graph.nodes) graphMap.set(n.id, { id: n.id, title: n.title });
  }

  // Determine renderIds array (the node sequence to render around circle)
  let renderIds: string[] = [];
  let renderLabels: string[] = [];

  if (ids && ids.length > 0) {
    renderIds = [...ids];
    renderLabels = renderIds.map((rid, idx) => graphMap.get(rid)?.title ?? titles[idx] ?? rid ?? `(node ${idx + 1})`);
  } else if (graph && graph.nodes && graph.nodes.length > 0) {
    // limit so that visualization remains readable; choose up to 10 nodes (you can increase)
    const MAX_NODES = 10;
    const take = graph.nodes.slice(0, MAX_NODES);
    renderIds = take.map((n) => n.id);
    renderLabels = take.map((n) => n.title ?? n.id);
  } else {
    // pure titles fallback
    renderLabels = [...titles];
    renderIds = renderLabels.map((_, i) => `local-${i}`);
  }

  // If currentTitle is provided, set labels[0] = currentTitle
  if (renderLabels.length > 0) {
    renderLabels[0] = currentTitle?.trim() || renderLabels[0];
  }

  const N = Math.max(2, renderLabels.length); // at least 2 for visualization

  // Build nodes positions on circle
  const nodes = Array.from({ length: N }).map((_, i) => {
    const a = (2 * Math.PI * i) / N - Math.PI / 2;
    return {
      x: CX + R * Math.cos(a),
      y: CY + R * Math.sin(a),
      angle: a,
      label: renderLabels[i] ?? `#${i + 1}`,
      id: renderIds[i] ?? `local-${i}`,
    };
  });

  // curveOutward calculates a cubic bezier path from node i -> j
  const curveOutward = (i: number, j: number, extraSign: 1 | -1 = 1) => {
    const A = nodes[i],
      B = nodes[j];

    // chord for trimming (direction of THIS arrow)
    let vx = B.x - A.x,
      vy = B.y - A.y;
    const d = Math.hypot(vx, vy) || 1;
    const ux = vx / d,
      uy = vy / d;

    // stable chord (unordered) -> left normal
    const ii = Math.min(i, j),
      jj = Math.max(i, j);
    const P = nodes[ii],
      Q = nodes[jj];
    let svx = Q.x - P.x,
      svy = Q.y - P.y;
    const sn = Math.hypot(svx, svy) || 1;
    const nx = -(svy / sn),
      ny = svx / sn; // stable left normal

    // outward vs inward: pick sign by dot with center->midpoint
    const mx0 = (A.x + B.x) / 2,
      my0 = (A.y + B.y) / 2;
    const cxm = mx0 - CX,
      cym = my0 - CY;
    const outwardSign: 1 | -1 = (nx * cxm + ny * cym) >= 0 ? 1 : -1;

    const s = (outwardSign * extraSign) as 1 | -1;

    // curvature amount
    const bend = Math.max(BEND_MIN, Math.min(BEND_MAX, d * BEND_K));

    // trimmed endpoints
    const p0 = { x: A.x + PAD * ux, y: A.y + PAD * uy };
    const p3 = { x: B.x - PAD * ux, y: B.y - PAD * uy };

    // offset midpoint outward
    const mx = mx0 + s * bend * nx;
    const my = my0 + s * bend * ny;

    // smooth controls aimed at the offset midpoint
    const t1 = 0.45,
      t2 = 0.55;
    const p1 = { x: p0.x + t1 * (mx - p0.x), y: p0.y + t1 * (my - p0.y) };
    const p2 = { x: p3.x + (1 - t2) * (mx - p3.x), y: p3.y + (1 - t2) * (my - p3.y) };

    return `M ${p0.x} ${p0.y} C ${p1.x} ${p1.y} ${p2.x} ${p2.y} ${p3.x} ${p3.y}`;
  };

  // Build edges to draw:
  // - existingEdges: for cycle visualization, we treat existing edges around ring (i+1 -> i)
  // - newEdge: 0 -> (N-1) (the new edge that completes the cycle)
  // Additionally, if full graph is present, we include any edges between rendered nodes (graph edges).
  const existingEdges = Array.from({ length: Math.max(0, N - 1) }).map((_, i) => ({
    d: curveOutward(i + 1, i, 1),
    from: nodes[i + 1].id,
    to: nodes[i].id,
  }));
  const newEdge = {
    d: N === 2 ? curveOutward(0, N - 1, -1) : curveOutward(0, N - 1, 1),
    from: nodes[0].id,
    to: nodes[N - 1].id,
  };

  // If graph provided: also prepare graphEdges between rendered node indices (for visualizing real graph edges)
  const graphEdgesToDraw: { d: string; from: string; to: string }[] = [];
  if (graph && graph.edges && graph.nodes) {
    const idToIndex = new Map<string, number>();
    nodes.forEach((n, idx) => idToIndex.set(n.id, idx));
    for (const e of graph.edges) {
      const fi = idToIndex.get(e.from);
      const ti = idToIndex.get(e.to);
      if (typeof fi === "number" && typeof ti === "number") {
        // don't duplicate ring edges/newEdge — allow them but they will overlap
        graphEdgesToDraw.push({ d: curveOutward(fi, ti, 1), from: e.from, to: e.to });
      }
    }
  }

  // Utility for textual nodes/edges panel
  const graphNodesText = (graph?.nodes ?? []).map((n) => ({ id: n.id, title: n.title ?? n.id }));
  const graphEdgesText = (graph?.edges ?? []).map((e) => ({ from: e.from, to: e.to }));

  // mark which rendered nodes are part of cycle (based on ids prop)
  const cycleSet = new Set((ids ?? []).map((x) => x));

  // label positioning helper
  const labelPos = (angle: number) => {
    const x = CX + (R + LABEL_OFFSET) * Math.cos(angle);
    const y = CY + (R + LABEL_OFFSET) * Math.sin(angle);
    const cos = Math.cos(angle);
    const anchor: "start" | "end" | "middle" = Math.abs(cos) < 0.2 ? "middle" : cos >= 0 ? "start" : "end";
    return { x, y, anchor };
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className="relative z-10 w-[760px] max-w-[96vw] overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-black/5">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <h3 className="text-sm font-semibold text-zinc-800">Dependency loop</h3>
          <button onClick={onClose} className="rounded p-1 text-zinc-500 hover:bg-zinc-100" aria-label="Close">
            <svg viewBox="0 0 20 20" className="h-5 w-5"><path d="M6 6l8 8M14 6l-8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
          </button>
        </div>

        <div className="p-4">
          {/* Legend */}
          <div className="mb-2 flex items-center gap-4 text-xs text-zinc-600">
            <span className="inline-flex items-center gap-2">
              <span className="inline-block h-2 w-4 rounded-sm" style={{ background: EDGE_EXISTING }} />
              Existing dependency
            </span>
            <span className="inline-flex items-center gap-2">
              <span className="inline-block h-2 w-4 rounded-sm" style={{ background: EDGE_NEW }} />
              New dependency you're adding
            </span>
          </div>

          <svg width={WIDTH} height={HEIGHT} className="mx-auto block">
            <defs>
              <marker id="arrow-old" markerWidth="12" markerHeight="8" refX="10" refY="4" orient="auto">
                <path d="M0,0 L10,4 L0,8 z" fill={EDGE_EXISTING} />
              </marker>
              <marker id="arrow-new" markerWidth="14" markerHeight="10" refX="12" refY="5" orient="auto">
                <path d="M0,0 L12,5 L0,10 z" fill={EDGE_NEW} />
              </marker>
              <filter id="soft" x="-20%" y="-20%" width="140%" height="140%">
                <feDropShadow dx="0" dy="0" stdDeviation="2" floodColor="#00000022" />
              </filter>
            </defs>

            {/* If graphEdgesToDraw present, draw them first in subtle color */}
            {graphEdgesToDraw.map((e, i) => (
              <path key={`ge-${i}`} d={e.d} fill="none" stroke={EDGE_EXISTING} strokeWidth={1.5} markerEnd="url(#arrow-old)" opacity={0.7} />
            ))}

            {/* existing ring edges */}
            {existingEdges.map((e, i) => (
              <path key={`old-${i}`} d={e.d} fill="none" stroke={EDGE_EXISTING} strokeWidth={2} markerEnd="url(#arrow-old)" />
            ))}

            {/* new edge */}
            <path d={newEdge.d} fill="none" stroke={EDGE_NEW} strokeWidth={3} markerEnd="url(#arrow-new)" filter="url(#soft)" />

            {/* nodes + labels */}
            {nodes.map((n, i) => {
              const isFirst = i === 0;
              const isLast = i === N - 1;
              const isInCycle = cycleSet.has(n.id);
              const lp = labelPos(n.angle);
              return (
                <g key={`n-${i}`}>
                  {isFirst && <circle cx={n.x} cy={n.y} r={NODE_R + 8} fill="none" stroke={NODE_RING} strokeWidth={2} />}
                  {isLast && <circle cx={n.x} cy={n.y} r={NODE_R + 6} fill="none" stroke={NODE_LAST} strokeDasharray="4 2" />}
                  <circle cx={n.x} cy={n.y} r={NODE_R} fill={isInCycle ? "#fff" : "#fff"} stroke={isInCycle ? "#f97316" : "#cbd5e1"} strokeWidth={isInCycle ? 2.5 : 1.5} />
                  <text x={lp.x} y={lp.y} textAnchor={lp.anchor} dominantBaseline="middle" className="fill-zinc-700 text-[12px]">
                    {n.label}
                  </text>
                </g>
              );
            })}
          </svg>

          {/* textual path */}
          <div className="mt-3 rounded-md bg-zinc-50 p-2 text-center text-xs text-zinc-600">
            {renderLabels.join(" → ")} <span className="text-zinc-400">→</span>{" "}
            <span style={{ color: EDGE_NEW, fontWeight: 600 }}>{renderLabels[0]}</span>
          </div>

          {/* Graph inspector: list nodes & edges returned by callable (if available) */}
          <div className="mt-4 grid grid-cols-2 gap-4 text-xs">
            <div>
              <div className="mb-1 font-medium text-zinc-700">Nodes (graph)</div>
              <div className="max-h-36 overflow-auto rounded border border-zinc-100 bg-white p-2 text-[13px]">
                {graphNodesText.length ? (
                  graphNodesText.map((n) => (
                    <div key={n.id} className="flex items-center justify-between gap-2 py-0.5">
                      <div className="truncate text-zinc-700">{n.title}</div>
                      <div className="ml-2 text-xs text-zinc-400">{n.id}</div>
                    </div>
                  ))
                ) : (
                  <div className="text-zinc-400">No nodes in graph</div>
                )}
              </div>
            </div>

            <div>
              <div className="mb-1 font-medium text-zinc-700">Edges (graph)</div>
              <div className="max-h-36 overflow-auto rounded border border-zinc-100 bg-white p-2 text-[13px]">
                {graphEdgesText.length ? (
                  graphEdgesText.map((e, idx) => (
                    <div key={`${e.from}-${e.to}-${idx}`} className="flex items-center justify-between gap-2 py-0.5">
                      <div className="truncate text-zinc-700">
                        {graphMap.get(e.from)?.title ?? e.from} → {graphMap.get(e.to)?.title ?? e.to}
                      </div>
                      <div className="ml-2 text-xs text-zinc-400">{e.from} → {e.to}</div>
                    </div>
                  ))
                ) : (
                  <div className="text-zinc-400">No edges in graph</div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2 border-t px-4 py-3">
          <button onClick={onClose} className="rounded-md border border-zinc-300 px-3 py-1.5 text-sm text-zinc-700 hover:bg-zinc-50">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
